import { render, staticRenderFns } from "./CaBottomNav.vue?vue&type=template&id=05d4a124"
import script from "./CaBottomNav.vue?vue&type=script&lang=js"
export * from "./CaBottomNav.vue?vue&type=script&lang=js"
import style0 from "./CaBottomNav.vue?vue&type=style&index=0&id=05d4a124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBottomNavigation,VIcon,VSpacer})
